import { render, staticRenderFns } from "./TableModalActions.vue?vue&type=template&id=2a14685f&"
import script from "./TableModalActions.vue?vue&type=script&lang=ts&"
export * from "./TableModalActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports